import General from "./general/general_details.store";
import Image from "./image/staff_image.store";

export default {
  modules: { General, Image },
};
